// extracted by mini-css-extract-plugin
export default {"videoContainer":"About_videoContainer__N1of+","video":"About_video__74smB"};